import { render, staticRenderFns } from "./Creatives.vue?vue&type=template&id=f131970c&scoped=true"
import script from "./Creatives.vue?vue&type=script&lang=js"
export * from "./Creatives.vue?vue&type=script&lang=js"
import style0 from "./Creatives.vue?vue&type=style&index=0&id=f131970c&prod&lang=scss&scoped=true"
import style1 from "./Creatives.vue?vue&type=style&index=1&id=f131970c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f131970c",
  null
  
)

export default component.exports